<template>
  <div class="fantan-mainbet">
    <div>
      <div
        class="square1"
        :class="{'square-active':(Array.isArray(win_kwok))?(win_kwok.includes(gameRow[3])):(win_kwok === gameRow[3])}"
      >
        <new-bet-lot
          class="fantan-kwok-three-four"
          game="fantan-kwok"
          display="kwok34"
          :key="o3"
          :type="gameRow[3]"
          :odd="odd(o3)"
          :category="o3"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow[3])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
      <div
        class="square2"
        :class="{'square-active':(Array.isArray(win_kwok))?(win_kwok.includes(gameRow[2])):(win_kwok === gameRow[2])}"
      >
        <new-bet-lot
          class="fantan-kwok-three-two"
          game="fantan-kwok"
          display="kwok23"
          :key="o3"
          :type="gameRow[2]"
          :odd="odd(o3)"
          :category="o3"
          :gameType="game"
          :game-data="gameData"
          :minutes-string="minutesString"
          :seconds-string="secondsString"
          :disallow-betting="disallowBetting"
          :stake-record-sum="stakeRecordSum(gameRow[2])"
          @update-session-storage="onUpdateSessionStorage"
        />
      </div>
    </div>
    <div>
      <div
        class="square3"
        :class="{'square-active':(Array.isArray(win_kwok))?(win_kwok.includes(gameRow[1])):(win_kwok === gameRow[1])}"
      >
        <span class="wordsOneFour">
          <new-bet-lot
            class="fantan-kwok-one-four"
            game="fantan-kwok"
            display="kwok14"
            :key="o3"
            :type="gameRow[1]"
            :odd="odd(o3)"
            :category="o3"
            :gameType="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(gameRow[1])"
            @update-session-storage="onUpdateSessionStorage"
          />
        </span>
      </div>
      <div
        class="square4"
        :class="{'square-active':(Array.isArray(win_kwok))?(win_kwok.includes(gameRow[0])):(win_kwok === gameRow[0])}"
      >
        <span class="wordsTwoOne">
          <new-bet-lot
            class="fantan-kwok-one-two"
            game="fantan-kwok"
            display="kwok12"
            :key="o3"
            :type="gameRow[0]"
            :odd="odd(o3)"
            :category="o3"
            :gameType="game"
            :game-data="gameData"
            :minutes-string="minutesString"
            :seconds-string="secondsString"
            :disallow-betting="disallowBetting"
            :stake-record-sum="stakeRecordSum(gameRow[0])"
            @update-session-storage="onUpdateSessionStorage"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Col, Button } from "iview";
import NewBetLot from "../../commons/NewBetLot";
import betLotMixin from "../../../mixins/bet-lot-mixin";

export default {
  mixins: [betLotMixin],
  props: ["game", "winNumbers", "gameData", "drawResult"],
  components: {
    Row,
    Col,
    Button,
    NewBetLot,
  },
  data() {
    return {
      o3: "o3",
      gameRow: ["kwok12", "kwok14", "kwok23", "kwok34"],
      winCell: [],
    };
  },
  computed: {
    win_kwok() {
      this.winCell = [];
      for (let i = 0; i < this.gameRow.length; i++) {
        if (this.drawResult[this.gameRow[i]] == "1") {
          this.winCell.push(this.gameRow[i]);
        }
      }

      return this.winCell;
    },
  },
};
</script>

<style lang="scss" scoped>
.fantan-mainbet {
  background-color: #000000;
  position: absolute;
  width: 100%;
  margin: 0px 0;
  height: 278px;
  // @extend .game-section;
}

.divider {
  height: 30px;
  display: block;
  clear: both;
}

.square1 {
  width: 25%;
  height: 73px;
  // float: left;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 0%
    0% no-repeat padding-box;
  position: absolute;
  cursor: pointer; //1017 ADDED
  // border: 2px solid #464A4B;
  border-radius: 10px;
  top: 0px;
  left: 0;
}

.square2 {
  width: 25%;
  height: 73px;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 0%
    0% no-repeat padding-box;
  position: absolute;
  cursor: pointer;
  // border: 2px solid #464A4B;
  border-radius: 10px;
  top: 0px;
  right: 0;
}

.square3 {
  width: 25%;
  height: 73px;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 0%
    0% no-repeat padding-box;
  position: absolute;
  cursor: pointer;
  // border: 2px solid #464A4B;
  border-radius: 10px;
  bottom: 0px;
  left: 0;
}

.square4 {
  width: 25%;
  height: 73px;
  background: transparent linear-gradient(180deg, #474b4c 0%, #111113 100%) 0%
    0% no-repeat padding-box;
  position: absolute;
  cursor: pointer;
  // border: 2px solid #464A4B;
  border-radius: 10px;
  bottom: 0px;
  right: 0;
}
.square-active {
  background: #6221f4;
  border: 1px solid #000000;
}
.fantan-kwok-three-four,
.fantan-kwok-three-two,
.fantan-kwok-one-four,
.fantan-kwok-one-two {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
